import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  useTheme,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  REBALANCER_SUMMARY as summaryHeader,
  TABLE_CROSS_TRADE as tableHeader,
} from "../../../../../../../component/Methods";

import { useDispatch, useSelector } from "react-redux";
import CrossingTradesTable from "./components/CrossingTradesTable";
import {
  addActiveRequests,
  updateLoading,
  updateLoadingMsg,
} from "../../../../../../../Redux/Reducers/uiSlice";
import SummaryTable from "./components/SummaryTable";
import { sendWebSocketMessage } from "../../../../../../../hooks/useWebSocket";
import { selectAllTrades, selectFinalCrossedTrades, selectProcessId } from "../../../../../../../Redux/Reducers/selectors";

const FundRebalanceStep7 = ({ rebalancedFunds, rebalanceType }) => {
  const AllTrades = useSelector(selectAllTrades);
  const finalCrossedTrades = useSelector(selectFinalCrossedTrades);
  const processId = useSelector(selectProcessId);
  const crossingTradesTableRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      rebalanceType === "all" &&
      processId &&
      processId != "" &&
      rebalancedFunds && rebalanceType === "all"
    ) {
      sendWebSocketMessage(
        JSON.stringify({
          action: "rebalancer_summary",
          data: {
            processId: processId,
            fundIds: rebalancedFunds,
            rebalancerType: 1,
          },
        })
      );
      dispatch(updateLoadingMsg("Generating Summary"));
      dispatch(updateLoading(true));
    }
  }, [processId,dispatch]);
  const onNext = () => {
    const ignoreList =
      crossingTradesTableRef.current?.getIgnoredTradeIds() || [];
    
  
    
    const socketRequest = {
      action: "finalize_rebalancer_orders",
      data: {
        fundIds: rebalancedFunds,
        processId: rebalanceType === "all" ? processId : AllTrades?.processId,
        rebalancerType: rebalanceType === "all" ? 1 : 0,
        ignoredTrades: ignoreList,
      },
    };

    sendWebSocketMessage(JSON.stringify(socketRequest));
    dispatch(addActiveRequests("finalize_rebalancer_orders"));
    dispatch(updateLoadingMsg("Generating Trades"));
    dispatch(updateLoading(true));
  };

  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "35%",
              }}
            >
              <Box
                sx={{
                  marginBottom: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold !important",
                    fontSize: "20px !important",
                  }}
                >
                  Final Trades
                </Typography>
              </Box>
            </div>
            {finalCrossedTrades && finalCrossedTrades.length > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  onClick={onNext}
                  sx={{ width: "200px", height: "40px" }}
                >
                  Send To Blotter
                </Button>
              </Box>
            ) : null}
          </div>
        </Grid>

        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            {finalCrossedTrades ? (
              <>
                <div style={{ width: "47%" }}>
                  <CrossingTradesTable
                    ref={crossingTradesTableRef}
                    crossingTrades={finalCrossedTrades}
                    tableHeader={tableHeader}
                  />
                </div>
                <div style={{ width: "1%" }}></div>
                <div style={{ width: "52%" }}>
                  <SummaryTable tableHeader={summaryHeader} />
                </div>
              </>
            ) : (
              <p>No data available</p>
            )}
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FundRebalanceStep7;
